module.exports = __webpack_public_path__ + "img/espace-qualite.5c2b02f7.jpg";